import { useState } from 'react';
import { CornerDownRight, Trash2 } from 'lucide-react';
import { useEditor } from '../../state/store';
import { Panel } from '../widgets/common';

/** Reusable snippets saved from a selection and stamped back onto the canvas. */
export function ComponentsPanel(): JSX.Element {
  const revision = useEditor((s) => s.revision);
  const cursor = useEditor((s) => s.cursor);
  const store = useEditor.getState();
  const tab = store.active();
  const [name, setName] = useState('');

  return (
    <Panel title={`Components (${tab.components.length})`} defaultOpen={false}>
      <div className="row" style={{ marginBottom: 8 }}>
        <input
          className="input"
          placeholder="Component name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <button
          className="btn"
          disabled={!name.trim()}
          title="Save the current selection as a reusable component"
          onClick={() => {
            store.saveComponent(name.trim());
            setName('');
          }}
        >
          Save
        </button>
      </div>

      {tab.components.length === 0 ? (
        <div className="empty-state">
          <span>Select an area, name it, then Save.</span>
        </div>
      ) : (
        <div key={revision}>
          {tab.components.map((c) => (
            <div key={c.id} className="item">
              <span className="name">{c.name}</span>
              <span className="tag">
                {c.width}×{c.height}
              </span>
              <button
                className="icon-btn"
                title={cursor ? `Insert at ${cursor.x},${cursor.y}` : 'Hover the canvas to choose a position'}
                onClick={() => store.stampComponent(c.id, cursor ?? { x: 0, y: 0 })}
              >
                <CornerDownRight size={13} />
              </button>
              <button
                className="icon-btn"
                title="Delete component"
                onClick={() => store.removeComponent(c.id)}
              >
                <Trash2 size={13} />
              </button>
            </div>
          ))}
        </div>
      )}
    </Panel>
  );
}
